import { RouteType } from "../types";
import { route } from "../utils";
import FulfillmentPage from "@/pages/fulfillment/fulfillment-page";
import { CreateFulfillmentPage } from "@/pages/fulfillment/create-fulfillment-page";
import { EditFulfillmentPage } from "@/pages/fulfillment/edit-fulfillment-page";

export const fulfillmentRoutes: Record<string, RouteType> = {
  list: route("/fulfillments", FulfillmentPage),
  new: route("/fulfillments/new", CreateFulfillmentPage),
  edit: route("/fulfillments/:id/edit", EditFulfillmentPage),
};
